<template>
  <Row>
    <Col span="24">
      <div class="res_div">
        <p class="res_div_p">{{ title }}</p>
        <div class="res_div_div"></div>
        <div style="text-align: center">
          <span class="news_ul_div_div02_sp"> 发布时间：2022-07-10 </span>
        </div>
        <div class="div_img01" v-for="(item, index) in img" :key="index">
          <span
            v-if="item.sp !== ''"
            :src="item.sp"
            style="
              font-size: 17px;
              font-weight: bold;
              color: #70a9f8;
              line-height: 34px;
            "
            >{{ item.sp }}</span
          >
          <p class="font_div">{{ item.p }}</p>
          <img v-if="item.imgUrl !== ''" :src="item.imgUrl" alt="暂无照片" />
          <img
            v-if="item.imgUrl02 !== ''"
            :src="item.imgUrl02"
            alt="暂无照片"
          />
          <img
            v-if="item.imgUrl03 !== ''"
            :src="item.imgUrl03"
            alt="暂无照片"
          />
        </div>
      </div>
    </Col>
  </Row>
</template>

<script>
export default {
  data() {
    return {
      title: "热烈欢迎内蒙古观摩团莅临南秀科技参观指导！",
      img: [
        {
          imgUrl: "../../../static/img/News/NewsNine/01.jpg",
          imgUrl02: "../../../static/img/News/NewsNine/02.jpg",
          imgUrl03: "",
          p: "7月9日上午，为加快推进智慧岛建设实施意见，高标准推进智慧岛建设，不断提升科技创新能力，内蒙古观摩团到智慧岛大厦，听取智慧岛双创载体建设发展情况汇报。",
        },
        {
          imgUrl: "../../../static/img/News/NewsNine/03.jpg",
          imgUrl02: "../../../static/img/News/NewsNine/04.jpg",
          imgUrl03: "",
          p: "南秀科技负责人王鹏超向领导们介绍南秀科技了的主要运营情况、经营模块以及主要产品。",
        },
      ],
    };
  },
  mounted() {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  },
  methods: {
    getUnderStandMore() {
      this.$router.push({
        name: "AR",
      });
    },
  },
};
</script>

<style scoped>
.res_div img {
  width: 100%;
  margin: 10px 0;
}

.res_div_p {
  font-size: 30px;
  font-weight: bold;
  color: #000;
}

.font_div {
  font-size: 16px;
  line-height: 26px;
  margin-bottom: 10px;
}

.res_div_div {
  border-bottom: 1px dashed #e1e1e1;
  margin: 10px 0;
}

.news_ul_div_div02_sp {
  font-size: 12px;
  color: #888;
  line-height: 30px;
}

.div_img01 img {
  width: 96%;
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/News/NewsNine.vue